import React, {useEffect, useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Helmet, HelmetProvider} from "react-helmet-async";
import styled from "styled-components";
import ListComponent from "../../components/ListComponent";
import {useDispatch, useSelector} from "react-redux";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {ApiParam} from "../../api/network/apiParams";
import {fetchWriting} from "../../api/redux/writing";
import {useLocation} from "react-router-dom";
import {useSearch} from "../../components/context/SearchContext";

const Material = () => {
    const dispatch = useDispatch();
    const location = useLocation(); // Get the location object
    const {query, setQuery} = useSearch(); // Use this if it returns an object

    // Parse query parameter from the URL
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const urlQuery = params.get("query");
        if (urlQuery) {
            setQuery(urlQuery); // Set query from URL
        }
    }, [location.search]);

    // API call
    useEffect(() => {
        const api_url = apiEndPoints.BLOG_LIST;
        const api_params = {
            [ApiParam.IMAGE]: "no",
            [ApiParam.POST]: "yes",
        };

        dispatch(fetchWriting([api_url, api_params]));
    }, [dispatch]);

    const getPost = useSelector((state) => state.writing);
    const data = getPost?.posts?.blogs;
    const filteredWriting = data?.filter((writing) => writing.data?.category_id === 20 && writing.data?.link === 'Material');

    const filteredItems = filteredWriting?.filter(item => {
        const productData = item?.data;

        // Safely check and convert each field to a string before calling `toLowerCase`
        return (
            productData?.title?.toLowerCase()?.includes(query.toLowerCase()) ||
            productData?.date?.toLowerCase()?.includes(query.toLowerCase())
        );
    });


    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Architech Shamsul Wares | Material</title>
                <meta name="Architech Shamsul Wares"
                      content="Our current mode and depiction of existence become almost incomprehensible due to the explosion of unimaginable visual."/>
            </Helmet>
            <StyledComponent>
                <Container>
                    <Row>
                        <Col lg={12}>
                            {/* Ensure filteredWriting is an array before calling map */}
                            <div className="category">
                                <h5>Material</h5>
                            </div>
                            {
                                filteredItems?.map(item => {
                                    return (
                                        <>
                                            <ListComponent category={item?.slug} url={'material'} data={item} />
                                        </>
                                    )
                                })
                            }
                        </Col>
                    </Row>
                </Container>
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`
    .category {
        margin-bottom: 30px;

        h5 {
            font-size: 16px;
            font-weight: bold;
            line-height: 18px;
        }
    }
`;

export default Material;
